import { makeStyles } from '@material-ui/core/styles';

const styles = {
  notification: {
    marginTop: 10,
    marginBottom: 10
  },
  notificationIcon: {
    marginLeft: 5,
    fill: 'red'
  }
}

export default makeStyles(styles)
